export default "__VITE_ASSET__CLWE6zRV__"